import { FormattedMessage } from "react-intl";
import NotificationTriggerIcon from "../../../../components/Common/SvgIcons/AdminIcons/EngagementCenterIcon/NotificationTriggerIcon";
import DeleteIcon from "../../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
import EditIcon from "../../../../components/Common/SvgIcons/TableIcons/EditIcon";
import Tooltip from "../../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../../tableColumnTypes";
import { admin } from "../admin";

export const engagementCenter = {
  name: <FormattedMessage id="ENGAGEMENT_CENTER_TEXT" />,
  path: (tenantName) => `${admin.path(tenantName)}/engagementCenter`,
  addNotificationPath: (tenantName) =>
    `${admin.path(tenantName)}/engagementCenter/addNotification`,
  editNotificationPath: (tenantName, notificationId) =>
    `${admin.path(
      tenantName
    )}/engagementCenter/editNotification/${notificationId}`,
  notificationHistoryPath: (tenantName) =>
    `${admin.path(tenantName)}/engagementCenter/notificationHistory`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: admin.name,
      path: admin.path(tenantName),
      onClick: () => navigate(admin.path(tenantName)),
    },
    {
      key: 2,
      label: engagementCenter.name,
      path: engagementCenter.path(tenantName),
      onClick: () => navigate(engagementCenter.path(tenantName)),
    },
  ],
  columns: (tenantName, handleNotificationModel, navigate) => [
    {
      ID: 1,
      name: <FormattedMessage id="NOTIFICATION_TEXT" />,
      fieldName: "Name",
      value: (row) => row.Name,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="NOTIFICATION_TYPE" />,
      fieldName: "NotificationTypeDisplayName",
      value: (row) => row.NotificationTypeDisplayName,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="IS_ACTIVE" />,
      fieldName: "IsActive",
      value: (row) => (row.IsActive ? "Yes" : "No"),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 4,
      name: <FormattedMessage id="DIST_HIST_LAST_MODIFIED" />,
      fieldName: "ModifiedOn",
      value: (row) => new Date(row.ModifiedOn).toLocaleString(),
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 5,
      name: <FormattedMessage id="Cer_Actions" />,
      fieldName: "",
      value: (row) => (
        <>
          <Tooltip content={<FormattedMessage id="MYCLASS_EDIT" />} direction={"bottom"}>
            <span
              onClick={() =>
                navigate(
                  engagementCenter.editNotificationPath(tenantName, row?.Id)
                )
              }
            >
              <EditIcon />
            </span>
          </Tooltip>
          <Tooltip
            content={<FormattedMessage id="NOTIFICATION_TYPE" />}
            direction={"bottom"}
            show={row?.IsActive && row?.IsEventBase}
          >
            <span
              style={{
                visibility:
                  row?.IsActive && row?.IsEventBase ? "visible" : "hidden",
              }}
              onClick={() => handleNotificationModel(row, true)}
            >
              <NotificationTriggerIcon />
            </span>
          </Tooltip>
          <Tooltip content={<FormattedMessage id="DISTRIBUTE_DELETE" />} direction={"bottom"}>
            <span onClick={() => handleNotificationModel(row?.Id, false)}>
              <DeleteIcon />
            </span>
          </Tooltip>
        </>
      ),
      sort: false,
    },
  ],
};
